export const RepositoryInterface = {
  find() {
  },
  list() {
  },
  create() {
  },
  edit() {
  },
  delete() {
  },
  partial_edit(){}
};

// function bind(repositoryName, Interface) {
export const bind = (repositoryFactory: any, Interface: any) => {
  return {
    ...Object.keys(Interface).reduce((prev, method) => {
      const resolveableMethod = async (...args: any) => {
        const repository = await repositoryFactory();
        // const repository = await import(`./repositories/${repositoryName}`);
        return repository.default[method](...args);
      };
      return {
        ...prev,
        [method]: resolveableMethod
      };
    }, {}),
  };
}
